import Link from 'next/link';

export type CTAProps = {
  href: string;
  title: string;
};

export default function CTA({ href, title }: CTAProps) {
  return (
    <Link href={href} prefetch={false}>
      <a className="text-rose font-medium text-[13px]">
        {title}
        <span className="inline-block ml-2">&#8594;</span>
      </a>
    </Link>
  );
}
